export default function Landing() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100">
      <header className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <nav className="flex justify-between items-center">
          <span className="text-2xl font-bold text-blue-600">BeatSending</span>
          <div className="flex gap-4">
            <a href="/login" className="px-4 py-2 text-gray-600 hover:text-gray-900">Login</a>
            <a href="/register" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Get Started</a>
          </div>
        </nav>
      </header>
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Schedule Messages<br />
            <span className="text-blue-600">That Matter</span>
          </h1>
          <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto">
            Schedule Email, SMS, and MMS messages in advance. Set up recurring messages or use Beat Sending to automatically send if you don't check in.
          </p>
          <div className="flex gap-4 justify-center">
            <a href="/register" className="px-8 py-4 bg-blue-600 text-white text-lg rounded-xl hover:bg-blue-700 transition-colors">
              Start Free Trial
            </a>
            <a href="#features" className="px-8 py-4 bg-white text-gray-700 text-lg rounded-xl border border-gray-300 hover:bg-gray-50 transition-colors">
              Learn More
            </a>
          </div>
        </div>
        
        <div id="features" className="mt-32 grid md:grid-cols-3 gap-8">
          <div className="card text-center">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-2">Scheduled Sending</h3>
            <p className="text-gray-600">Schedule messages for any date and time. Perfect for reminders and follow-ups.</p>
          </div>
          
          <div className="card text-center">
            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-2">Recurring Messages</h3>
            <p className="text-gray-600">Set up daily, weekly, or monthly recurring messages. Never miss an important date.</p>
          </div>
          
          <div className="card text-center">
            <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-2">Beat Sending</h3>
            <p className="text-gray-600">Messages sent automatically if you don't punch in. Perfect for safety check-ins.</p>
          </div>
        </div>
        
        <div className="mt-32">
          <h2 className="text-3xl font-bold text-center mb-12">Simple Pricing</h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="card">
              <h3 className="text-lg font-semibold text-gray-500">Free</h3>
              <div className="text-4xl font-bold my-4">$0<span className="text-lg font-normal text-gray-500">/mo</span></div>
              <ul className="space-y-2 text-gray-600 mb-6">
                <li>5 SMS</li>
                <li>10 Emails</li>
                <li>Basic scheduling</li>
              </ul>
              <a href="/register" className="btn btn-secondary w-full">Get Started</a>
            </div>
            
            <div className="card border-2 border-blue-500 relative">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-500 text-white px-3 py-1 rounded-full text-sm">Popular</div>
              <h3 className="text-lg font-semibold text-gray-500">Starter</h3>
              <div className="text-4xl font-bold my-4">$4.99<span className="text-lg font-normal text-gray-500">/mo</span></div>
              <ul className="space-y-2 text-gray-600 mb-6">
                <li>100 SMS</li>
                <li>Unlimited emails</li>
                <li>File attachments</li>
                <li>Recurring messages</li>
              </ul>
              <a href="/register" className="btn btn-primary w-full">Get Started</a>
            </div>
            
            <div className="card">
              <h3 className="text-lg font-semibold text-gray-500">Business</h3>
              <div className="text-4xl font-bold my-4">$29.99<span className="text-lg font-normal text-gray-500">/mo</span></div>
              <ul className="space-y-2 text-gray-600 mb-6">
                <li>1500 SMS</li>
                <li>MMS support</li>
                <li>Multi-recipient</li>
                <li>Team access</li>
              </ul>
              <a href="/register" className="btn btn-secondary w-full">Get Started</a>
            </div>
          </div>
        </div>
      </main>
      
      <footer className="bg-gray-900 text-white py-12 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-400">© 2024 BeatSending. All rights reserved.</p>
        </div>
      </footer>
    </div>
  )
}
